import { IBindable, IRaisePropertyChanged } from "bindable-data";
import { Event } from "event-system";
import { Object3D } from "three";

export class BindableObject3D extends Object3D implements IRaisePropertyChanged, IBindable {
    public readonly propertyChanged: Event<IBindable, string>;

    public constructor() {
        super();
        this.propertyChanged = new Event();
        
    }

    protected onPropertyChanged(propertyName: string): void {
        this.propertyChanged.emit(this, propertyName);
    }

    public raisePropertyChanged(propertyName: string): void {
        this.onPropertyChanged(propertyName);
    }
}
